import { render } from "./UpcomingEpisodes.vue?vue&type=template&id=13c993ea&ts=true"
import script from "./UpcomingEpisodes.vue?vue&type=script&lang=ts"
export * from "./UpcomingEpisodes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__